import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContractStatus from 'components/Credit24/SelfService/ContractStatus';
import PositionedOverlay from 'components/Credit24/SelfService/Overlays/PositionedOverlay';
import cx from 'classnames';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  selfservice: PropTypes.object.isRequired,
  setUpgradeHighlightOff: PropTypes.func.isRequired,
  applyIncrease: PropTypes.func,
};

class ContractStatusSection extends Component {
  constructor() {
    super();
    this.state = {
      sectionRef: null,
    };
    this.setSectionRef = this.setSectionRef.bind(this);
    this.isSmallPadding = this.isSmallPadding.bind(this);
  }

  setSectionRef(node) {
    this.setState({
      sectionRef: node,
    });
  }

  isSmallPadding() {
    const {
      selfservice: { isUpgradeSuccess, isNativeAdvertisingEnabled, contracts },
      authentication,
    } = this.props;

    const contractId = authentication.contracts[0];
    const contract = contracts[contractId] || {};

    const isContractFrozen = contract.CONTRACT_FREEZE && contract.CONTRACT_FREEZE.enabled;

    return !(isUpgradeSuccess && isNativeAdvertisingEnabled)
    && contract.upgrade
    && contract.upgrade.product
    && isNativeAdvertisingEnabled
    && !isContractFrozen;
  }

  render() {
    const { setUpgradeHighlightOff, selfservice, authentication } = this.props;

    const contentBlockClassname = cx({
      'content-block': true,
      'content-block--small-padding': this.isSmallPadding(),
    });

    return ([
      <div className={contentBlockClassname} ref={this.setSectionRef} key="contractStatus">
        <ContractStatus
          authentication={authentication}
          selfservice={selfservice}
          setUpgradeHighlightOff={setUpgradeHighlightOff}
          isInDashboard
          applyIncrease={this.props.applyIncrease}
        />
      </div>,
      <PositionedOverlay
        key="contractStatusHighlighted"
        nodeRef={this.state.sectionRef}
        isOpen={selfservice.isUpgradeHighlighted && selfservice.isNativeAdvertisingEnabled}
        onBackdropClick={setUpgradeHighlightOff}
        onEscapeKeyUp={setUpgradeHighlightOff}
      >
        <ContractStatus
          authentication={authentication}
          selfservice={selfservice}
          setUpgradeHighlightOff={setUpgradeHighlightOff}
          isInDashboard
          isUpgradeHighlighted={selfservice.isUpgradeHighlighted}
          applyIncrease={this.props.applyIncrease}
        />
      </PositionedOverlay>,
    ]);
  }
}

ContractStatusSection.propTypes = propTypes;

export default ContractStatusSection;
